<template>
	<div class="creator--overview" style="height:100%;">
		<div class="container">
			<div class="creator">
				<div class="left">
					<router-link class="creator__link selected" to="/creator/">{{$t('page.creator.items')}}</router-link>
					<router-link class="creator__link" to="/account/">{{$t('page.creator.account')}}</router-link>
				</div>
				<div class="right">
					<div class="plugin__header">
						<h1>{{$t('page.creator.items')}}</h1>
						<div>
							<btn v-if="checkForAdmin()" @click="showPluginOverlay()" :text="'New Plugin'" />
							<btn @click="showOverlay()" :text="$t('page.creator.new_item')" />
						</div>
					</div>
					<div class="search--wrapper">
						<input class="input--text" v-model="searchTerm" type="text" :placeholder="$t('header.searchbar.placeholder')" />
					</div>
					<div v-if="plugins">
						<template v-if="plugins.plugins && Object.keys(plugins.plugins).length > 0">
							<h3 v-if="showPluginHeadline">Plugins:</h3>
							<template v-for="plugin in plugins.plugins" :key="plugin.id">
								<div class="plugin__entry" v-if="plugin.visible">
									<router-link :to="{path: '/creator/edit/' + plugin.plugin_id + '/listing/'}" class="plugin__entry--left">
										<plugin-logo :size="40" :type="plugin.image.type" :path="plugin.image.path"></plugin-logo>
										<div class="plugin__entry--meta">
											<div class="plugin__name"><b>{{plugin.displayname}}</b> - {{plugin.technology}}</div>
											<div class="plugin__version">Version {{plugin.plugin_version}}</div>
										</div>
									</router-link>
									<div class="entry__right--wrapper">
										<div class="plugin__entry--right">
											<span class="entry__right--status">{{getStatusText(plugin.status, plugin.public)}}</span>
										</div>
										<div @click="deletePlugin(plugin)" class="delete--plugin">
											<span>&nbsp;</span>
											<span>&nbsp;</span>
										</div>
									</div>
								</div>
							</template>
						</template>
						<template v-if="plugins.addons && Object.keys(plugins.addons).length > 0">
							<h3 v-if="showTemplateHeadline">Templates:</h3>
							<template v-for="plugin in plugins.addons" :key="plugin.id">
								<div class="plugin__entry" v-if="plugin.visible">
									<router-link :to="{path: '/creator/edit/' + plugin.plugin_id + '/listing/'}" class="plugin__entry--left">
										<plugin-logo :size="40" :type="plugin.image.type" :path="plugin.image.path"></plugin-logo>
										<div class="plugin__entry--meta">
											<div class="plugin__name"><b>{{plugin.displayname}}</b> - {{plugin.technology}}</div>
											<div class="plugin__version">Version {{plugin.plugin_version}}</div>
										</div>
									</router-link>
									<div class="entry__right--wrapper">
										<div class="plugin__entry--right">
											<span class="entry__right--status">{{getStatusText(plugin.status, plugin.public)}}</span>
										</div>
										<div @click="deletePlugin(plugin)" class="delete--plugin">
											<span>&nbsp;</span>
											<span>&nbsp;</span>
										</div>
									</div>
								</div>
							</template>
						</template>
						<template v-if="!showPluginHeadline && !showTemplateHeadline">
							<div class="no--results">
								<h3>No Results Found</h3>
								<p>There are no results that match your search. Please try again with another search term.</p>
							</div>
						</template>
					</div>
					<placeholder v-else :type="'page.creator'"></placeholder>
				</div>
			</div>
		</div>
		<div v-if="overlayVisible" @click.self="hideOverlay()" class="overlay__container">
			<div class="overlay__box">
				<div class="create__new step--1" v-if="currentStep == 1">
					<h2>{{$t('page.creator.add_new_item')}}</h2>
					<p class="label">{{$t('page.creator.title')}}</p>
					<p class="info">{{$t('page.creator.title_text')}}</p>
					<input v-model="title" type="text" id="title" name="title">
					<p class="info">{{$t('page.creator.upload_text')}}</p>
					<div class="upload__box">
						<template v-if="files && files.length > 0">
							<div class="upload__entry" v-for="(file, index) in files" :key="file">
								<span class="title">{{file.name}}</span>
								<span @click="removeFile(index)" class="remove">{{$t('page.creator.remove')}}</span>
							</div>
						</template>
						<div v-if="!files || files.length == 0" class="upload__box--entry">
							<input @change="handleFileChange()" type="file" id="files" ref="files" name="files" accept="text/xml">
							<label for="files" class="background">
								<label for="files" class="button">{{$t('page.creator.upload_select')}}</label>
							</label>
						</div>
					</div>
					<div class="upload__navigation">
						<btn @click="hideOverlay()" :class="'btn--small btn--ghost'" :text="$t('page.creator.cancel')" />
						<btn @click="uploadFiles(true, (files && files.length > 0 && title && title.length > 5));" :class="['btn--small', {'disabled' : (!files || files.length == 0 || title.length < 5)}]" :text="$t('page.creator.next')" />
					</div>
				</div>
				<div class="close__overlay" @click="hideOverlay()">
					<span>&nbsp;</span>
					<span>&nbsp;</span>
				</div>
			</div>
		</div>
		<div v-if="checkForAdmin() && pluginOverlayVisible" @click.self="hideOverlay()" class="overlay__container">
			<div class="overlay__box">
				<div class="create__new step--1" v-if="currentStep == 1">
					<h2>{{$t('page.creator.add_new_plugin')}}</h2>
					<p class="label">{{$t('page.creator.title')}}</p>
					<p class="info">{{$t('page.creator.plugin_title_text')}}</p>
					<input v-model="title" type="text" id="title" name="title">
					<div class="upload__navigation">
						<btn @click="hideOverlay()" :class="'btn--small btn--ghost'" :text="$t('page.creator.cancel')" />
						<btn @click="uploadFiles(false, (title.length > 5));" :class="['btn--small', {'disabled' : (title.length < 5)}]" :text="$t('page.creator.next')" />
					</div>
				</div>
				<div class="close__overlay" @click="hideOverlay()">
					<span>&nbsp;</span>
					<span>&nbsp;</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import PluginLogo from '@/components/PluginLogo.vue';
import Placeholder from '@/components/Placeholder.vue';
import Btn from '@/components/Button.vue';

export default {
	components: {
		PluginLogo,
		Placeholder,
		Btn
	},
	data() {
		return {
			plugins: null,
			pluginOverlayVisible: false,
			overlayVisible: false,
			files: null,
			filesSelected: 0,
			currentStep: 1,
			title: '',
			searchTerm: '',
			fileObject: [],
			showPluginHeadline: true,
			showTemplateHeadline: true,
		}
	},
	methods: {
		checkForAdmin() {
			if(this.$store.state.userData && this.$store.state.userData.user_group_id == 1) {
				return true;
			}else {
				return false;
			}
		},
		deletePlugin(plugin) {
				let formData = new FormData();

				formData.append('plugin_id', plugin.id);

			axios({
				method: 'post',
				crossDomain: true,
				withCredentials: true,
				url: 'https://api.library.loxone.com/deletePlugin',
				data: formData
			}).then(response => {
				axios({
					method: 'post',
					crossDomain: true,
					withCredentials: true,
					url: 'https://api.library.loxone.com/loadPluginList'
				}).then(response => {
					this.plugins = response.data;
				});
			});
		},
		langChange(event, data){
			data['language'] = event;
		},
		hideOverlay() {
			this.overlayVisible = false;
			this.pluginOverlayVisible = false;
		},
		showOverlay() {
			this.overlayVisible = true;
		},
		showPluginOverlay() {
			this.pluginOverlayVisible = true;
		},
		handleFileChange() {
			this.files = Array.from(this.$refs.files.files);
		},
		openListingDetails(page) {
			this.overlayVisible = false;
			this.pluginOverlayVisible = false;
			this.title = '';
			this.files = null;
			axios({
				method: 'post',
				crossDomain: true,
				withCredentials: true,
				url: 'https://api.library.loxone.com/loadPluginList'
			}).then(response => {
				this.plugins = response.data;
			});

			if(page != "" && page != null && page != undefined) {
				this.$router.push({ name: 'CreatorListing', params: { id: page }})
			}
		},
		uploadFiles(files = true, valid = false) {
			if(valid) {
				let formData = new FormData();

				formData.append('name', this.title);
				if(files) {
					for( var i = 0; i < this.files.length; i++ ){
						let file = this.files[i];
						formData.append('files[' + i + ']', file);
					}
				} else {
					formData.append('plugin', true);
				}

				axios.post( 'https://api.library.loxone.com/insertPlugin',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						crossDomain: true,
						withCredentials: true,
					},
				).then(response => {
					if(response.data.valid) {
						this.openListingDetails(response.data.id);
					}else {
						this.$store.dispatch('addNotification', {title: this.$t('notification.error'), text: this.$t(response.data.error), type: 'error'});
					}
				});
			}
		},
		removeFile(index) {
			this.files.splice(index, 1);
		},
		getStatusText(status, is_public) {
			if(is_public) {
				is_public = 1;
			}
			switch(status) {
					case 0:
						return this.$t('status.draft');			// Draft
					case 1:
						return this.$t('status.review');		// In Review
					case 2:
						if(is_public) {
							return this.$t('status.published') + ' • ' + this.$t('status.approved');     // Published - Approved
						} else {
							return this.$t('status.private') + ' • ' + this.$t('status.approved');     // Private - Approved
						}
					case 3:
						return this.$t('status.declined');      //  Declined
					case 9:
						return this.$t('status.archive');      //  Archive
			}
		},
	},
	created() {
		axios({
			method: 'post',
			crossDomain: true,
			withCredentials: true,
			url: 'https://api.library.loxone.com/loadPluginList'
		}).then(response => {
			this.plugins = response.data;
		});
	},
	watch: {
		searchTerm: {
			deep: true,
			handler() {
				
				this.showPluginHeadline = false;
				if(this.plugins.plugins) {
					for (const [key, value] of Object.entries(this.plugins.plugins)) {
						value.visible = true;
						if (!value.displayname.toLowerCase().includes(this.searchTerm.toLowerCase()) && !value.technology.toLowerCase().includes(this.searchTerm.toLowerCase())) {
							value.visible = false;
						}else {
							this.showPluginHeadline = true;
						}
					}
				}

				this.showTemplateHeadline = false;
				if(this.plugins.addons) {
					for (const [key, value] of Object.entries(this.plugins.addons)) {
						value.visible = true;
						if (!value.displayname.toLowerCase().includes(this.searchTerm.toLowerCase()) && !value.technology.toLowerCase().includes(this.searchTerm.toLowerCase())) {
							value.visible = false;
						}else {
							this.showTemplateHeadline = true;
						}
					}
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
	@import '../scss/utilities/variables';
	@import '../scss/pages/creator';

	.creator div h3{
		margin-bottom: 10px;
		margin-top: 35px;

		&:first-child{
			margin-top: 0;
		}
	}
	.search--wrapper{
		display: flex;
		justify-content: flex-end;
	}

	.no--results{
		h3{
			margin-top: 10px !important;
		}
	}

	h1{
		margin-top: 0;
		line-height: 48px;
	}
</style>
